/* src/app/pages/casos/verpaciente/verpaciente.component.scss */
/*# sourceMappingURL=verpaciente.component.css.map */
